import React, { useEffect } from "react";
import { Title, Text, Image, Spacer, CustomLink } from "../dynamic.components";
import { useStore } from "src/store";
import { playCustomAnimation } from "src/services/animations";
import {
  componentAnimationReadyToPlay,
  componentAnimationReadyToStop,
} from "src/utils/helper";

export const HeighAdjustment: React.FC = () => {
  const {
    sidebarStatus,
    animationStopped,
    setAnimationStopped,
    activeSubLink: { text },
  } = useStore();

  useEffect(() => {
    if (componentAnimationReadyToPlay("1-4")) {
      playCustomAnimation();
    }
    if (componentAnimationReadyToStop("1-4")) {
      setAnimationStopped(true);
    }
  }, [sidebarStatus, animationStopped]);

  return (
    <>
      <Title title={text} />
      <div className="c-sidebar__body">
        <Text text="Users can easily adjust the keyboard and screen height for comfort." />
      </div>
    </>
  );
};
